<button
  bitIconButton="bwi-trash"
  buttonType="danger"
  size="small"
  type="button"
  class="tw-border-none"
  [appA11yTitle]="'deleteAttachmentName' | i18n: attachment.fileName"
  [bitAction]="delete"
></button>
